export function generateQueryParams(obj) {
  const params = Object.keys(obj)
    .filter(
      key => obj[key] !== null && obj[key] !== undefined && obj[key] !== ''
    )
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&');
  return params;
}
